export class CopyLink {
    constructor() {
        this.init();
    }

    async copyText(text) {
        if (!text) {
            return;
        }

        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return;
        }

        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        textarea.style.pointerEvents = 'none';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    }

    init() {
        window.addEventListener("click", async (e) => {
            const trigger = e.target.closest('[data-copy-link]');
            if (!trigger) {
                return;
            }

            const copyLink = trigger.getAttribute("data-copy-link");
            if (!copyLink) {
                return;
            }

            if (trigger.tagName === 'A' || trigger.tagName === 'BUTTON') {
                e.preventDefault();
            }

            try {
                await this.copyText(copyLink);
            } catch (error) {
                // No-op: silently fail to avoid blocking UX.
            }
        });
    }
}
